import { StepLabel, useMediaQuery } from '@material-ui/core';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Stepper from '@material-ui/core/Stepper';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { connect, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setStep } from '../../redux/scholarship.actions';
import { selectStep, selectSteps, selectStepsCompleted } from '../../redux/scholarship.selectors';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%'
    },
    bar: {
      // backgroundColor: '#fafafa',
      // backgroundColor: '#ffffff',
      backgroundColor: '#f3f6fd',
      marginBottom: theme.spacing(0)
    },
    button: {
      marginRight: theme.spacing(1)
    },
    completed: {
      display: 'inline-block'
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    alternativeLabel: {
      marginTop: '0px!important'
    },
    labelContainer: {
      marginTop: '6px'
    }
  })
);

interface IStepItem {
  id: string;
  label: string;
  num: number;
}

const HorizontalNonLinearStepperBar = ({ id, dispatchSetStep }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const steps = useSelector<unknown, IStepItem[]>(selectSteps as (state: unknown) => IStepItem[]);
  const activeStep = useSelector<unknown, number>(selectStep as (state: unknown) => number);
  const completed = useSelector<unknown, Record<number, boolean>>(selectStepsCompleted as (state: unknown) => Record<number, boolean>);
  const showButtonLabels = useMediaQuery('(min-width: 475px)');

  const handleStep = (step: number) => () => {
    if (id !== 'new') {
      dispatchSetStep(undefined, step);
      navigate(`/applications/${id}/${steps[step].id}`);
    }
  };

  return (
    <div className={classes.root}>
      <Stepper nonLinear activeStep={activeStep} className={classes.bar} alternativeLabel>
        {steps.map((item, index) => (
          <Step key={item.id}>
            <StepButton onClick={handleStep(index)} completed={completed[index]}>
              {showButtonLabels && (
                <StepLabel classes={{ alternativeLabel: classes.alternativeLabel, labelContainer: classes.labelContainer }}>
                  {item.label}
                </StepLabel>
              )}
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  dispatchSetStep: (oldStep, newStep) => dispatch(setStep(oldStep, newStep))
});

export default connect(null, mapDispatchToProps)(HorizontalNonLinearStepperBar);
